export default __webpack_public_path__ + "static/sittingOnMoney-6248d62de72c076dcb8ab4b813ceac29.svg";